"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const IWallet_1 = require("../models/wallets/IWallet");
const GenericValidator_1 = __importDefault(require("./GenericValidator"));
const paymentTypes = Object.values(IWallet_1.IPaymentType);
class WalletValidator extends GenericValidator_1.default {
    _schema = joi_1.default.object({
        id: joi_1.default.string().allow('').required(),
        orgKey: joi_1.default.string().required(),
        customerId: joi_1.default.string().required(),
        isC2: joi_1.default.number().required(),
        addedBy: joi_1.default.string().required(),
        sharedWith: joi_1.default.array().items(joi_1.default.string()).optional(),
        nickname: joi_1.default.string().optional(),
        expirationDate: joi_1.default.string().length(4).optional(),
        paymentType: joi_1.default.string()
            .valid(...paymentTypes)
            .required(),
        paymentInfo: joi_1.default.object({
            type: joi_1.default.string().optional(),
            last4: joi_1.default.string().optional(),
            firstName: joi_1.default.string().required(),
            lastName: joi_1.default.string().required(),
            zip: joi_1.default.string().required(),
        }).required(),
        paymentToken: joi_1.default.string().required(),
        paymentTokenId: joi_1.default.string().required(),
    }).required();
    validate(input) {
        super.validate(input, 'IWallet', this._schema);
    }
}
exports.default = WalletValidator;
